// MQ
import { isLessThan } from 'utils/mq';

// TweenLite + ScrollToPlugin
import TweenLite from 'gsap/TweenMax';
import ScrollToPlugin from 'gsap/ScrollToPlugin';

// Header Class
class Header {

  /**
   * Constructor:
   * Header constructor called in `manager.js` file.
   *
   * @constructor
   * @param {Object} options - Header class options
   */
  constructor({ el }) {
    // Root
    this.$root = el;

    // Menu
    this.$menu = [...this.$root.querySelectorAll('a')];
    this.$burger = this.$root.querySelector('.site-header-burger');

    // Scroll
    this.scroll = 0;
    this.min = 140;
    this.max = 280;

    // Events
    window.addEventListener('scroll', this.onScroll.bind(this));

    for (let i = 0; i < this.$menu.length; i++) {
      this.$menu[i].addEventListener('click', (e) => {
        // Prevent
        e.preventDefault();

        // Get href
        const href = e.currentTarget.getAttribute('href');

        // Close Mobile Menu
        document.body.classList.remove('has-menu');

        // Scroll to href
        TweenLite.to(window, 1.2, {
          scrollTo: href,
          ease: Expo.easeOut
        });
      });
    }

    this.$burger.addEventListener('click', () => {
      document.body.classList.toggle('has-menu');
    });
  }

  /**
   * Scroll:
   * Watch window scroll.
   */
  onScroll() {
    // Lock on Mobile
    if (isLessThan('l')) {
      return;
    }

    const y = window.pageYOffset;

    if (y >= this.min) {
      if (y >= this.max) {
        if(!this.$root.classList.contains('is-sticky')) {
          // Sticky
          this.$root.classList.add('is-sticky');
        }

        if (y > this.scroll) {
          // Hide
          TweenLite.to(this.$root, 1, {
            yPercent: -100,
            ease: Expo.easeOut
          });
        } else {
          // Show
          TweenLite.to(this.$root, 1, {
            yPercent: 0,
            ease: Expo.easeOut
          });
        }
      } else {
        // Hide
        TweenLite.to(this.$root, 1, {
          yPercent: -100,
          ease: Expo.easeOut
        });
      }
    } else {
      if(this.$root.classList.contains('is-sticky')) {
        // Kill Tweens
        TweenLite.set(this.$root, { clearProps: 'all' });
        TweenLite.killTweensOf(this.$root);

        // No Sticky
        this.$root.classList.remove('is-sticky');
      }
    }

    this.scroll = y;
  }
}

export default Header;
